
import { defineComponent, ref } from 'vue'
import HeaderHjpTable from '@/views/components/header/HeaderHjpTable.vue'
import HjpTabView from '@/views/components/tab/HjpTabView.vue'
import ActiveReportVerbal from '@/views/pages/verbal-report/ActiveReport.vue'
import Card from 'primevue/card'
import $ from 'jquery'
import '../verpal-report/verpal-report.scss'

export default defineComponent({
  name: 'VerbalReport',
  components: {
    HjpTabView,
    HeaderHjpTable,
    Card,
    ActiveReportVerbal
  },
  setup() {
    const activeTab = ref<number>(0)
    const searchValue = ref<string>('')
    const refHeaderHjp = ref()
    const onSearch = (search: string) => {
      searchValue.value = search
    }
    const tabsChange = (val: number) => {
      searchValue.value = ''
      activeTab.value = val
      $('.input-search-header-custom').children('.input-primary').val('')
    }
    return {
      activeTab,
      onSearch,
      searchValue,
      refHeaderHjp,
      tabsChange
    }
  }
})
